/*
 *             Copyright (c) 2016 - 2021, CKSource - Frederico Knabben. All rights reserved.
 *
 *
 *
 *
 *          +---------------------------------------------------------------------------------+
 *          |                                                                                 |
 *          |                                 Hello stranger!                                 |
 *          |                                                                                 |
 *          |                                                                                 |
 *          |   What you're currently looking at is the source code of a legally protected,   |
 *          |    proprietary software. Any attempts to deobfuscate / disassemble this code    |
 *          |               are forbidden and will result in legal consequences.              |
 *          |                                                                                 |
 *          |                                                                                 |
 *          +---------------------------------------------------------------------------------+
 *
 *
 *
 *
 */
var _0x2965=['type','deletion'];(function(_0x41c4d5,_0x296539){var _0x12acaf=function(_0x475c93){while(--_0x475c93){_0x41c4d5['push'](_0x41c4d5['shift']());}};_0x12acaf(++_0x296539);}(_0x2965,0x178));var _0x12ac=function(_0x41c4d5,_0x296539){_0x41c4d5=_0x41c4d5-0x0;var _0x12acaf=_0x2965[_0x41c4d5];return _0x12acaf;};export default function ts(_0x4b08bc){return _0x4b08bc['sort']((_0x352384,_0x105d08)=>_0x12ac('0x1')==_0x352384[_0x12ac('0x0')]&&_0x12ac('0x1')!=_0x105d08[_0x12ac('0x0')]?-0x1:_0x12ac('0x1')!=_0x352384[_0x12ac('0x0')]&&_0x12ac('0x1')==_0x105d08[_0x12ac('0x0')]?0x1:0x0);}